// Id_ENU_ContractStatus
export enum ContractStatus {
    REGISTERED = 3,
    UNDERWRITING = 4,
    ACCEPTED = 5,
    DECLINED = 6,
    TERMINATED = 8,
}
